function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 118,
  cy: 530.23257,
  rx: 118,
  ry: 9,
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M344.468,315.84454l-47.07583-12.83886q18.85578-17.793,16.40521-33.5237H344.468Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#9f616a"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "161.211 496.376 146.005 498.515 127.687 330.184 98.443 497.802 82.751 498.515 82.751 285.961 179.756 285.961 161.211 496.376",
  fill: "#2f2e41"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M278.89831,710.69308h0a10.69525,10.69525,0,0,0,10.60707-7.816l1.11072-16.57479-2.23906-11.75506c-5.90752-4.85489-11.87976-4.75376-17.91246,0L268.541,699.16917A10.69524,10.69524,0,0,0,278.89831,710.69308Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#2f2e41"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M341.66608,710.69308h0a10.69525,10.69525,0,0,0,10.60707-7.816l1.11072-16.57479-2.23905-11.75506c-5.90753-4.85489-11.87976-4.75376-17.91247,0l-1.92359,24.62195A10.69525,10.69525,0,0,0,341.66608,710.69308Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#2f2e41"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 149.79858,
  cy: 84.10538,
  r: 27.10427,
  fill: "#9f616a"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M372.28555,469.91089H268.86137c13.40488-62.12418,13.36732-112.15823,2.68969-152.62266a10.81293,10.81293,0,0,1,6.57562-12.85324l27.82474-10.70182c8.35359,10.788,20.1417,15.5,38.51659,8.55924l14.58078,2.99093a14.98248,14.98248,0,0,1,11.957,15.66542c-1.07315,15.82559-.65,31.77226-1.57328,45.538C366.57335,409.115,365.33855,442.34709,372.28555,469.91089Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M323.78318,228.82559s15.69194-17.83176,34.237-.71327l4.99289,1.42654-3.56635,2.85308s18.545,8.55924,17.11849,26.391c0,0-2.85308-.71327-4.27962,0s-2.13982,8.55924-2.13982,8.55924-2.13981-5.70616-2.85308-6.41943-10.699,7.846-27.10426-4.99289c0,0-4.99289,12.83886-10.699,11.41232s-13.55214-.71327-17.11849,8.55925C312.37085,275.90142,293.11256,234.53175,323.78318,228.82559Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#2f2e41"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M377.27844,454.219l-9.15617,12.272a12.02693,12.02693,0,0,0,2.59424,16.93944l0,0a12.02693,12.02693,0,0,0,18.92117-7.8472l2.61941-16.37132L397.25,388.5981l-3.56635-35.66351L370.859,361.49383l6.41944,30.67062Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#9f616a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M368.00592,370.05307l27.81754-12.83886-1.42654-10.10582a41.48828,41.48828,0,0,0-26.4891-38.68205l-8.46114-3.28085Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M266.72156,451.36587l9.15617,12.272a12.02693,12.02693,0,0,1-2.59424,16.93944l0,0a12.02693,12.02693,0,0,1-18.92117-7.8472l-2.61941-16.37132L246.75,385.745l3.56635-35.66351,22.82465,8.55924-6.41944,30.67062Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#9f616a"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M275.99408,367.2l-27.81754-12.83886,1.42654-10.10582a41.48828,41.48828,0,0,1,26.4891-38.68205l8.46114-3.28085Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1004.25,640.11628h-476a7.5082,7.5082,0,0,1-7.5-7.5v-207a7.5082,7.5082,0,0,1,7.5-7.5h476a7.5082,7.5082,0,0,1,7.5,7.5v207A7.5082,7.5082,0,0,1,1004.25,640.11628Zm-476-219a4.50492,4.50492,0,0,0-4.5,4.5v207a4.50491,4.50491,0,0,0,4.5,4.5h476a4.50491,4.50491,0,0,0,4.5-4.5v-207a4.50492,4.50492,0,0,0-4.5-4.5Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M547.75,443.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M979.04035,474.91143V558.361H554.20958V514.42334c2.94182-1.88912,5.90143-3.76937,8.88768-5.58753,12.75379-7.80481,26.40529-15.10408,41.28325-17.80921a62.31953,62.31953,0,0,1,21.31262-.26606c7.46567,1.23282,14.61134,3.80489,21.68594,6.38578,6.9768,2.55431,13.9714,5.18841,21.2682,6.66959a62.2716,62.2716,0,0,0,21.5704.4257c13.66035-2.04876,26.49415-7.53875,39.27457-12.50543,12.86049-4.99332,26.112-9.7117,40.03011-10.33255,13.74031-.62085,27.31181,2.62528,40.35,6.65184,26.58306,8.20394,53.726,20.37239,81.87329,12.02652,28.58273-8.46112,54.87248-32.8867,86.54811-25.64059A1.19244,1.19244,0,0,1,979.04035,474.91143Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M979.04035,476.366a1.28259,1.28259,0,0,1-1.45455.63855,47.36842,47.36842,0,0,0-11.5121-1.18843c-31.15722.54988-55.11271,25.63172-85.57811,29.38339-27.46769,3.37913-53.32114-9.97776-79.148-16.95775-13.419-3.62749-27.25483-5.55207-41.06406-3.08649-13.70274,2.439-26.563,8.0443-39.4764,13.01992-12.43452,4.78929-25.35683,9.2416-38.82014,9.46333-14.80256.24831-28.13287-5.85365-41.86225-10.50106-7.13963-2.42125-14.46553-4.337-22.03086-4.52323a66.64492,66.64492,0,0,0-21.71164,3.36138c-14.58971,4.63858-27.7337,12.90455-40.53188,21.11737a1.13679,1.13679,0,0,1-.75385.204,1.37378,1.37378,0,0,1-.58534-2.50109l.58534-.37255c2.93567-1.88912,5.8891-3.76937,8.86911-5.58753,12.72717-7.80481,26.35017-15.10408,41.19707-17.80921a62.06159,62.06159,0,0,1,21.26813-.26606c7.45008,1.23282,14.58083,3.80489,21.64067,6.38578,6.96223,2.55431,13.94222,5.18841,21.22379,6.66959a62.014,62.014,0,0,0,21.52537.4257c13.63183-2.04876,26.43884-7.53875,39.19258-12.50543,12.83364-4.99332,26.05747-9.7117,39.94654-10.33255,13.71162-.62085,27.25479,2.62528,40.26577,6.65184,26.52756,8.20394,53.61383,20.37239,81.70236,12.02652,28.52306-8.46112,54.75793-32.8867,86.36743-25.64059a1.1897,1.1897,0,0,1,.745.47A1.36658,1.36658,0,0,1,979.04035,476.366Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#ff7e67"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 424.49576,
  cy: 311.45889,
  r: 6.20838,
  fill: "#ff7e67"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 581.47916,
  cy: 303.47668,
  r: 6.20838,
  fill: "#ff7e67"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 773.05211,
  cy: 295.49447,
  r: 6.20838,
  fill: "#ff7e67"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M609.25,593.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 380.5,
  cy: 417.23257,
  r: 17,
  fill: "#ff7e67"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M761.25,593.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 532.5,
  cy: 417.23257,
  r: 17,
  fill: "#ff7e67"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M913.25,593.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 684.5,
  cy: 417.23257,
  r: 17,
  fill: "#ff7e67"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "e1cfef3e-7788-4f0f-b252-d185c9336b04",
  "data-name": "Path 78",
  d: "M971.669,362.2257H736.831c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9H971.669c4.578,0,8.288,2.643,8.293,5.9v51.041C979.958,359.58171,976.247,362.2217,971.669,362.2257Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54H971.669c2.747,0,4.973-1.586,4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M789.92905,328.39087a5.00589,5.00589,0,0,0-5,5v35a5.00589,5.00589,0,0,0,5,5h179a5.00589,5.00589,0,0,0,5-5v-35a5.00588,5.00588,0,0,0-5-5Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#ff7e67"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 626.67905,
  cy: 171.00715,
  r: 11,
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M865.06094,346.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "b00e8b21-64f0-4b6c-8490-a93637cb24e1",
  "data-name": "Path 78",
  d: "M795.669,243.2257H560.831c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9H795.669c4.578,0,8.288,2.643,8.293,5.9v51.041C803.958,240.58171,800.247,243.2217,795.669,243.2257Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54H795.669c2.747,0,4.973-1.586,4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#e6e6e6"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M613.92905,209.39087a5.00589,5.00589,0,0,0-5,5v35a5.00589,5.00589,0,0,0,5,5h179a5.00589,5.00589,0,0,0,5-5v-35a5.00588,5.00588,0,0,0-5-5Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#ff7e67"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 450.67905,
  cy: 52.00715,
  r: 11,
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M689.06094,227.61628a4.5,4.5,0,0,0,0,9h63a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-188.25 -180.38372)",
  fill: "#fff"
});

function SvgCreateADataset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf74385c-6483-43b7-aa3a-5b28e4e3e168",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 823.5 539.23257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateADataset);
export default __webpack_public_path__ + "static/media/create-a-dataset.b05bb7d0.svg";
export { ForwardRef as ReactComponent };